export default "__VITE_ASSET__DTS8VRV5__"